import React, {MouseEvent} from 'react'

import Icon from "react-icons-kit/Icon";
import {infoCircle} from "react-icons-kit/fa/infoCircle";

import clsx from 'clsx'
import { ls } from '../../../locale'

export function FareLabels() {
  
  const rFareRule = ls.t('FareRule')
  
  return (
    <div className={clsx('tw-hidden',
      'md:tw-grid md:tw-grid-rows-subgrid md:tw-row-span-11'
    )}>
      <div></div>
      <FareItemBox><FareLabel label={rFareRule.HandLuggage.Label} icon='handbag' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CheckInLuggage.Label} icon='checkedbag' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.PriorityCheckin.Label} icon='priority' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.Seat.Label} icon='seat' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.Meal.Label} icon='meal' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.OnlineCheckin.Label} icon='online' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CounterCheckin.Label} icon='counter' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.ChangeFlight.Label} icon='change' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CancelFlight.Label} icon='cancellation' /></FareItemBox>
      <div></div>
    </div>
  )
}

export function FareItemBox({hideBottomLineInMobile = false, children}: {hideBottomLineInMobile?: boolean, children?: React.ReactNode}) {
  return (
    <div className='tw-px-3 tw-flex tw-items-stretch'>
      <div className={clsx('tw-w-full tw-py-2',
        'tw-flex tw-items-center tw-justify-center tw-border-solid tw-border-0 tw-border-gray-200',
        hideBottomLineInMobile ? 'md:tw-border-b ' : 'tw-border-b'
      )}>
        {children}
      </div>
    </div>
  )
}

export function FareItemDetail({ label, icon, children }: { label: string, icon: string, children: string | React.ReactNode }) {
  return (
    <div className='tw-w-full tw-flex tw-justify-between md:tw-block'>
      <div className='tw-grow md:tw-hidden'><FareLabel label={label} icon={icon} /></div>
      <FareItemValue>{children}</FareItemValue>
    </div>
  )
}

const handleTooltipClick = (e:MouseEvent<HTMLButtonElement>) => e.stopPropagation();

export function FareItemDetailWithInfo({label, icon, tooltipId, children}: {tooltipId: string, label: string, icon: string, children: string | React.ReactNode}) {

  return (
    <div className='tw-w-full tw-flex tw-justify-between md:tw-block'>
      <div className='tw-grow md:tw-hidden'><FareLabel label={label} icon={icon} /></div>
      { !children || children === 'X' 
        ?<FareItemValue>{children}</FareItemValue>
        : <div className='tw-flex tw-justify-center tw-gap-1'>
          <span className='tw-text-start'><FareItemValue>{children}</FareItemValue></span>
          <span><Icon icon={infoCircle} data-tip data-tooltip-id={tooltipId} data-type="error" onClick={handleTooltipClick}/></span>
        </div>
      }
    </div>
  )
}

function FareLabel({ label, icon }: { label: string, icon: string }) {
  const values = label?.split(/\r\n|\r|\n/) ?? [];
  return (
    <div className='tw-w-full tw-flex tw-justify-start tw-items-start tw-gap-1'>
      <i className={`picon picon-${icon}`} />
      <div>{values.map((v,i) => <span className='tw-block' key={i}>{v}</span>)}</div>
    </div>
  )
}


function FareItemValue({children}: {children: string | React.ReactNode}) {
  if(!children) return <i className="picon picon-cross"/>;
  if(typeof children !== 'string') return children;

  return (!children.trim() || children === 'X') ? <i className="picon picon-cross"/> : children
}
